import { render, staticRenderFns } from "./RowButtonCard.vue?vue&type=template&id=b58c7628&scoped=true"
import script from "./RowButtonCard.vue?vue&type=script&lang=js"
export * from "./RowButtonCard.vue?vue&type=script&lang=js"
import style0 from "./RowButtonCard.vue?vue&type=style&index=0&id=b58c7628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58c7628",
  null
  
)

export default component.exports